<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Can't find opportunities that cater to your needs?</h2>
    <p>
      Use this feature to get the opportunities you want to hear about. Opt in to get notified with matching Opportunity Marketplaces.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Opportunities for African Businesses</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'future-interest',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Future Interest Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Future Interest Block',
      })
      this.$router.push({ path: '/about/deals' })
    },
  },
}
</script>
